import { handleServiceRequest } from '../handle-service-request';
import { fakeResponses } from './fake-academic-affairs-response';
import { authHeader } from 'helpers/auth-header';
import { api_base_url, axiosInstance } from '../common.service';
import { handleError } from 'shared';
import { UrlEnum } from 'shared';
import {
    convertApiResponseToOppositeSearchOptions,
    convertApiResponseToSearchOptions,
} from '../shared-service-functions';

const baseUrl = `/api/AcademicPrograms`;

const searchAcademicPrograms = params => {
    const object = {
        url: `${baseUrl}/program/search`,
        postBody: params,
        customHandleError: error => {
            const returned = fakeResponses.fakeSearchAcademicPrograms();
            return returned;
        },
    };
    return handleServiceRequest.post(object);
};

const uploadFiles = (files, requestId) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
        formData.append('Files', files[i]);
    }
    formData.append('RequestId', requestId);
    const object = {
        url: `${baseUrl}/programRequests/uploadAttachments`,
        postBody: formData,
    };
    return handleServiceRequest.post(object);
};

const downloadAttachment = (id, filename) => {
    const obj = {
        url: `${baseUrl}/programRequests/download/${id}`,
        filename: filename,
    };
    return handleServiceRequest.download(obj);
};

const searchProgramRequests = params => {
    const object = {
        url: `${baseUrl}/programRequests/search`,
        postBody: params,
    };
    return handleServiceRequest.post(object);
};

const editProgramRequest = params => {
    const object = {
        url: `${baseUrl}/programRequests/edit`,
        postBody: params,
    };
    return handleServiceRequest.post(object);
};

const createProgramRequest = params => {
    console.log(params);
    const object = {
        url: `${baseUrl}/programRequests/create`,
        postBody: params,
    };
    return handleServiceRequest.post(object);
};

const getAllProgramRequests = status => {
    const getObject = {
        url: `${baseUrl}/programRequests/getAll/${status}`,
    };
    return handleServiceRequest.get(getObject);
};

const getSplitProgramRequests = requestId => {
    const getObject = {
        url: `${baseUrl}/programRequests/split/${requestId}`,
    };
    return handleServiceRequest.get(getObject);
};

const getProgramRequestLogs = requestId => {
    if (requestId === -1 || requestId === undefined) return;
    const getObject = {
        url: `${baseUrl}/programRequests/get/${requestId}`,
    };
    return handleServiceRequest.get(getObject);
};

const changeProgramRequestStatus = (requestId, statusId, postData) => {
    if (requestId === -1 || requestId === undefined) return;
    console.log(postData);
    const getObject = {
        url: `${baseUrl}/programRequests/changeStatus/${requestId}/${statusId}`,
        postBody: postData,
    };
    return handleServiceRequest.post(getObject);
};

const massProgramRequestStatusChange = (statusId, postData) => {
    console.log(statusId);
    console.log(postData);
    const getObject = {
        url: `${baseUrl}/programRequests/changeStatus/multiple/${statusId}`,
        postBody: postData,
    };
    return handleServiceRequest.post(getObject);
};

const getProgramExtraViewDetails = id => {
    const getObject = {
        url: `${baseUrl}/program/extraViewDetails/${id}`,
    };
    return handleServiceRequest.get(getObject);
};

const getAcademicProgram = (id, isEditing = 0) => {
    const getObject = {
        url: `${baseUrl}/program/${id}/${isEditing}`,
    };
    return handleServiceRequest.get(getObject);
};

/* Sample Response 
[
    {
        "programID: 3,
        "institutionName: "Purdue University-West Lafayette",
        "degreeLevel: null,
        "cipCode: null,
        "cipTitle: "None",
        "programName: "Associate in Agriculture in General Agriculture",
        "status: "Eliminated",
        "approvalDate: "1971-08-04T00:00:00",
        "hasPendingActionRequests: false,
        "monthYearIdentifier: null,
        "monthYearText: "None Set"
    }, 
    ...
]
*/

const createNewProgram = postBody => {
    const postObject = {
        url: `${baseUrl}/program`,
        postBody: postBody,
    };
    return handleServiceRequest.post(postObject);
};

const deleteProgram = id => {
    const myObject = {
        url: `${baseUrl}/program/delete/${id}`,
    };
    return handleServiceRequest.post(myObject);
};

const getAcademicProgramRequests = id => {
    const getObject = {
        url: `${baseUrl}/program/${id}/requests`,
    };
    return handleServiceRequest.get(getObject);
};

const getProgramReviewReport = params => {
    const getObject = {
        url: `${baseUrl}/ProgramReviewReport`,
        params: params,
    };
    // [FromQuery] UnitType institutionLevel = UnitType.Institution, //1 = institution, 2 = campus, 3 = location
    //         [FromQuery] List<DataOutputs> dataOutputs = null,
    //         [FromQuery] List<ProgramsToInclude> programsToInclude = null,
    //         [FromQuery] List<string> fiscalYears = null,
    //         [FromQuery] List<string> institutionTypes = null,
    //         [FromQuery] List<string> institutions = null,
    //         [FromQuery] List<string> degreeLevels = null,
    //         [FromQuery] List<string> metaMajor = null,
    //         [FromQuery] List<string> cips = null,
    //         [FromQuery] string name = null,
    //         [FromQuery] bool? stemStatus = null,
    //         [FromQuery] List<string> programStatus = null,
    //         [FromQuery] DistanceCodes.DistanceEdCode distanceEd = DistanceCodes.DistanceEdCode.All
    return handleServiceRequest.getWithParams(getObject);
};

const getProgramReviewReportExport = params => {
    const getObject = {
        url: `${baseUrl}/ProgramReviewReportExport`,
        params: params,
    };
    // [FromQuery] UnitType institutionLevel = UnitType.Institution, //1 = institution, 2 = campus, 3 = location
    //         [FromQuery] List<DataOutputs> dataOutputs = null,
    //         [FromQuery] List<ProgramsToInclude> programsToInclude = null,
    //         [FromQuery] List<string> fiscalYears = null,
    //         [FromQuery] List<string> institutionTypes = null,
    //         [FromQuery] List<string> institutions = null,
    //         [FromQuery] List<string> degreeLevels = null,
    //         [FromQuery] List<string> metaMajor = null,
    //         [FromQuery] List<string> cips = null,
    //         [FromQuery] string name = null,
    //         [FromQuery] bool? stemStatus = null,
    //         [FromQuery] List<string> programStatus = null,
    //         [FromQuery] DistanceCodes.DistanceEdCode distanceEd = DistanceCodes.DistanceEdCode.All,
    //         [FromQuery] bool groupPrograms = false
    return handleServiceRequest.getWithParams(getObject);
};

const getLocations = (search = '') => {
    const getObject = {
        url: `${baseUrl}/locations?${search}`,
    };
    return handleServiceRequest.get(getObject);
};

const getAllProgramDetailsFromInstitution = (search = '') => {
    const getObject = {
        url: `${baseUrl}/institution/programs?${search}`,
    };
    return handleServiceRequest.get(getObject);
};

const getOptions = () => {
    const getObject = {
        url: `${baseUrl}/options`,
    };
    return handleServiceRequest.get(getObject);
};

const getCips = () => {
    const cachedData = localStorage.getItem('cipsCache');
    if (cachedData) {
        return Promise.resolve(JSON.parse(cachedData));
    }

    const fetchPromise = Promise.all([
        handleServiceRequest.getWithParams({ url: '/api/AcademicPrograms/TwoDigitCIP' }),
        handleServiceRequest.getWithParams({ url: '/api/AcademicPrograms/FourDigitCIP' }),
        handleServiceRequest.getWithParams({ url: '/api/AcademicPrograms/SixDigitCIP' }),
    ]).then(data => {
        localStorage.setItem('cipsCache', JSON.stringify(data));
        return data;
    });

    return fetchPromise;
};

const getProgramRequestTypes = () => {
    const cachedData = localStorage.getItem('programRequestTypes');

    if (cachedData) {
        /*const parsedData = JSON.parse(cachedData);

        if (
            parsedData.timestamp &&
            new Date().getTime() - parsedData.timestamp < 8 * 60 * 60 * 1000 // if more than 8 hours old
        ) {
            return Promise.resolve(parsedData.value);
        }
        */
    }

    const getObject = {
        url: `${baseUrl}/programRequestTypes`,
    };

    const fetchPromise = handleServiceRequest.get(getObject).then(data => {
        const object = { value: data, timestamp: new Date().getTime() };
        localStorage.setItem('programRequestTypes', JSON.stringify(object));
        return data;
    });

    return fetchPromise;
};

const getSixCips = () => {
    const cachedData = localStorage.getItem('SixDigitCIP');

    if (cachedData) {
        const parsedData = JSON.parse(cachedData);

        if (
            parsedData.timestamp &&
            new Date().getTime() - parsedData.timestamp < 8 * 60 * 60 * 1000 // if more than 8 hours old
        ) {
            return Promise.resolve(parsedData.value);
        }
    }

    const getObject = {
        url: `/api/AcademicPrograms/SixDigitCIP`,
    };

    const fetchPromise = handleServiceRequest.get(getObject).then(data => {
        const object = { value: data, timestamp: new Date().getTime() };
        localStorage.setItem('SixDigitCIP', JSON.stringify(object));
        return data;
    });

    return fetchPromise;
};

const getProgramStatusTypes = search => {
    const getObject = {
        url: `${baseUrl}/programStatusTypes`,
    };
    return handleServiceRequest.get(getObject);
}

const getInstitutions = search => {
    const getObject = {
        url: `${baseUrl}/institutions?${search}`,
        //convertFunction: function(resp) { convertApiResponseToSearchOptions(resp.institutions); }
        convertFunction: function(responses) {
            return responses.institutions.map(response => ({
                label: response.id,
                value: response.text ? response.text : response.name,
                editable: response.editable,
            }));
        },
    };
    return handleServiceRequest.get(getObject);
};

const getDegreeLevels = () => {
    const cachedData = localStorage.getItem('degreeLevelsCache');

    if (cachedData) {
        /* const parsedData = JSON.parse(cachedData);

        if (
            parsedData.timestamp &&
            new Date().getTime() - parsedData.timestamp < 8 * 60 * 60 * 1000 // if more than 8 hours old
        ) {
            return Promise.resolve(parsedData.value);
        }
        */
    }

    const getObject = {
        url: `${baseUrl}/degreeLevels`,
        convertFunction: function(responses) {
            return responses.degreeLevels.map(response => ({
                label: response.id,
                value: response.text ? response.text : response.name,
            }));
        },
    };

    const fetchPromise = handleServiceRequest.get(getObject).then(data => {
        const object = { value: data, timestamp: new Date().getTime() };
        localStorage.setItem('degreeLevelsCache', JSON.stringify(object));
        return data;
    });

    return fetchPromise;
};

async function getDistanceEds() {
    const getObject = {
        url: `${baseUrl}/distanceEds`,
    };

    let result = await handleServiceRequest.get(getObject);
    return result;
}

async function getDistanceEdsOnline() {
    const getObject = {
        url: `${baseUrl}/distanceEdsOnline`,
    };

    let result = await handleServiceRequest.get(getObject);
    return result;
}

const getInstitutionTypes = () => {
    const getObject = {
        url: `${baseUrl}/institutionTypes`,
    };
    return handleServiceRequest.get(getObject);
};

const getAuditsListWithId = id => {
    const getObject = {
        url: `${baseUrl}/Audits/list/${id}`,
    };
    return handleServiceRequest.get(getObject);
};

const updateNewAcademicAffair = (id, params) => {
    const patchObject = {
        url: `${baseUrl}/program/${id}`,
        params: params,
    };
    return handleServiceRequest.patch(patchObject);
};

const editAcademicProgram = params => {
    const myObject = {
        url: `${baseUrl}/program/${params.programId}`,
        patchBody: params,
    };
    return handleServiceRequest.patch(myObject);
};

const getCredentialInformation = id => {
    const getObject = {
        url: `${baseUrl}/credentials/${id}`,
    };
    return handleServiceRequest.get(getObject);
};

const editCredential = params => {
    const myObject = {
        url: `${baseUrl}/credentials/${params.CredentialId}`,
        patchBody: params,
    };
    return handleServiceRequest.patch(myObject);
};

const createCredential = postBody => {
    const postObject = {
        url: `${baseUrl}/credential`,
        postBody: postBody,
    };
    return handleServiceRequest.post(postObject);
};

export const academicProgramsService = {
    searchAcademicPrograms,
    uploadFiles,
    downloadAttachment,
    searchProgramRequests,
    getAllProgramRequests,
    getProgramRequestLogs,
    getAllProgramDetailsFromInstitution,
    editProgramRequest,
    createProgramRequest,
    changeProgramRequestStatus,
    massProgramRequestStatusChange,
    createCredential,
    editCredential,
    getAcademicProgramRequests,
    getProgramRequestTypes,
    getCredentialInformation,
    getProgramExtraViewDetails,
    getAcademicProgram,
    createNewProgram,
    getProgramReviewReport,
    getProgramReviewReportExport,
    getLocations,
    getOptions,
    getCips,
    getSixCips,
    getSplitProgramRequests,
    getInstitutions,
    getInstitutionTypes,
    getAuditsListWithId,
    updateNewAcademicAffair,
    getDegreeLevels,
    getDistanceEdsOnline,
    editAcademicProgram,
    getDistanceEds,
    deleteProgram,
    getProgramStatusTypes
};
